import { AuthService } from "src/app/shared/services";
import { AuthTokenService } from "./../shared/services/http-client/auth-token.service";
import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from "@angular/common/http";
import { switchMap, tap } from "rxjs/operators";

import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Utils } from './../utils/utils';
import { Constant } from "./services/constant";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private token: AuthTokenService, private auth: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req: string;
    // Get the auth token from the service.
    let urlparams=request.urlWithParams;
    let updatedHeaders = request.headers;
    // if (!urlparams.includes("isRefresh=true")) {
    //   updatedHeaders = updatedHeaders.set('user-key', '8dd41ba2d4fb9c706ec7ac383456ad96');
    // } else {
    //   updatedHeaders = updatedHeaders.set('user-key', '21e49dd3df44772a14a40ef68d56deb5');
    // }
    if(!urlparams.includes("isRefresh=true"))
      updatedHeaders = request.headers.set('user-key', '4acfa633e4ba665aabb7397b87646ace');
     else
       updatedHeaders = request.headers.set('user-key', '21e49dd3df44772a14a40ef68d56deb5');
    request = request.clone({ headers: updatedHeaders });
    const accessToken = localStorage.getItem('access_token');

    const idToken = localStorage.getItem('id_token');
    if (request.url !== Constant.URL) {
      req = request.url;
      if (!req.includes('blob')) {
        request = request.clone({
          setHeaders: {
            // authorization1: `Bearer ${accessToken}`,
            authorization: `Bearer ${idToken}`
          }
        });

        return next.handle(request)
      .pipe(
        //retry(1),
        catchError((error: HttpErrorResponse) => {
          if(error.status==403){
            return this.auth.getRefreshtokenStorage().pipe(
              switchMap(() => {
                // Retry the original request with the new token
                const newAccessToken = this.token.getAccessToken;
                const newIdToken = this.token.getIdToken;
                if (newAccessToken && newIdToken) {
                  request = request.clone({
                    setHeaders: {
                      // authorization1: `Bearer ${newAccessToken}`,
                      authorization: `Bearer ${newIdToken}`
                    }
                  });
                }
                return next.handle(request);
              })
            );

          }
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            if (error.status === 403) {

              Utils.alertWithErrorMessage("Token is expired or invalid. You will redirect to login.!");
              this.token.clearTokens();
              setTimeout(() => {
                localStorage.removeItem("access_token");
                this.auth.redirectToDaimler('login');
              }, 5000);
            }
          }
          return throwError(errorMessage);
        })
      );
      }

      else {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json; charset=utf-8',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
            'If-Modified-Since': '0'
          }
        });
        return next.handle(request)
      }  // send cloned request with header to the next handler.
    }
    else {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=utf-8',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'If-Modified-Since': '0',
          Authorization: ``
        }
      });
      return next.handle(request);
    }
   
    
  }
}
